window.theoricLoginPopup = {
  _elements: null,
  _isInitialized: false,

  _openInternal: function () { },
  _closeInternal: function () { },
  _switchTabInternal: function (tab) { },

  open: function () {
    this._isInitialized ? this._openInternal() : console.error("Popup not initialized.");
  },
  close: function () {
    this._isInitialized ? this._closeInternal() : console.error("Popup not initialized.");
  }
};

document.addEventListener('DOMContentLoaded', () => {
  const elements = {
    trigger: document.getElementById('login-popup-trigger'),
    overlay: document.getElementById('login-popup-overlay'),
    closeButton: document.getElementById('close-login-popup'),
    statusContainer: document.getElementById('login-popup-status'),
    tabs: document.querySelectorAll('.popup-tab-link'),
    tabContents: document.querySelectorAll('.popup-tab-content'),
    loginForm: document.getElementById('customer_login_popup'),
    emailInput: document.getElementById('customer_email_popup'),
    passwordInput: document.getElementById('customer_password_popup'),
    registerForm: document.querySelector('#login-popup-overlay #create_customer')
  };

  window.theoricLoginPopup._elements = elements;

  if (!elements.overlay) {
    return;
  }

  const showStatusMessage = (message, type = 'error', targetContainer = elements.statusContainer) => {
    if (!targetContainer) return;
    targetContainer.innerHTML = `<p>${message}</p>`;
    targetContainer.className = `login-popup-status ${type}`;
    targetContainer.style.display = 'block';
  };

  const clearStatusMessage = () => {
    if (elements.statusContainer) {
      elements.statusContainer.innerHTML = '';
      elements.statusContainer.style.display = 'none';
    }
  };

  const resetForms = () => {
    elements.loginForm?.reset();
    elements.registerForm?.reset();
  };

  const showLoading = (form, show = true) => {
    const button = form.querySelector('button[type="submit"]');
    if (button) {
      button.disabled = show;
      button.textContent = show ? 'Aguarde...' : button.dataset.originalText;
    }
  };

  window.theoricLoginPopup._openInternal = function () {
    elements.overlay.style.display = 'flex';
    setTimeout(() => elements.overlay.classList.add('active'), 10);
    scrollLock.lock();
  };

  window.theoricLoginPopup._closeInternal = function () {
    elements.overlay.classList.remove('active');
    setTimeout(() => {
      elements.overlay.style.display = 'none';
      resetForms();
      clearStatusMessage();

      elements.tabContents.forEach(content => content.classList.remove('active'));
      elements.tabs.forEach(tab => tab.classList.remove('active'));
      if (elements.tabs.length > 1) {
        elements.tabs[1].classList.add('active');
        const defaultContentId = elements.tabs[1].dataset.tab;
        const defaultContent = document.getElementById(defaultContentId);
        if (defaultContent) defaultContent.classList.add('active');
      }
    }, 350);
    scrollLock.unlock();
  };

  window.theoricLoginPopup._switchTabInternal = function (clickedTab) {
    const targetContentId = clickedTab.dataset.tab;

    elements.tabs.forEach(tab => tab.classList.remove('active'));
    elements.tabContents.forEach(content => content.classList.remove('active'));

    clickedTab.classList.add('active');
    const targetContent = document.getElementById(targetContentId);
    if (targetContent) {
      targetContent.classList.add('active');
    }

    resetForms();
    clearStatusMessage();
  };

  if (elements.trigger) {
    elements.trigger.addEventListener('click', (e) => {
      e.preventDefault();
      window.theoricLoginPopup.open();
    });
  }

  elements.closeButton.addEventListener('click', () => window.theoricLoginPopup.close());
  elements.overlay.addEventListener('click', (e) => {
    if (e.target === elements.overlay) window.theoricLoginPopup.close();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && elements.overlay.classList.contains('active')) {
      window.theoricLoginPopup.close();
    }
  });

  elements.tabs.forEach(tab => {
    tab.addEventListener('click', () => window.theoricLoginPopup._switchTabInternal(tab));
  });

  if (elements.registerForm) {
    const registerButton = elements.registerForm.querySelector('button[type="submit"]');
    if (registerButton) {
      registerButton.dataset.originalText = registerButton.textContent;
    }

    elements.registerForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      clearStatusMessage();
      showLoading(elements.registerForm, true);

      try {
        const formData = new FormData(elements.registerForm);
        const response = await fetch(elements.registerForm.action, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          body: new URLSearchParams(formData).toString()
        });

        if (response.ok || (response.redirected && response.url.includes('/account'))) {
          // GA4 — sign_up
          try {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'sign_up',
              method: 'email'
            });
          } catch(e) {}
          showStatusMessage('Conta criada com sucesso! Agora você pode entrar com sua senha.', 'success');
          setTimeout(() => {
            if (elements.tabs.length > 0) {
              window.theoricLoginPopup._switchTabInternal(elements.tabs[0]);
            }
          }, 2500);
        } else {
          const errorHtml = await response.text();
          const newDoc = new DOMParser().parseFromString(errorHtml, 'text/html');
          const formErrors = newDoc.querySelector('.form-status--error, .errors');
          const errorMessage = formErrors ? formErrors.innerText.trim() : 'Não foi possível criar a conta. Verifique os dados e tente novamente.';
          showStatusMessage(errorMessage);
        }
      } catch (error) {
        console.error('Registration Error:', error);
        showStatusMessage('Erro de conexão. Verifique sua internet e tente novamente.');
      } finally {
        showLoading(elements.registerForm, false);
      }
    });
  }

  // GA4 — login (form submit)
  if (elements.loginForm) {
    elements.loginForm.addEventListener('submit', () => {
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'login',
          method: 'email'
        });
      } catch(e) {}
    });
  }

  window.theoricLoginPopup._isInitialized = true;
});
